import React from "react"
import * as style from "./benefits.module.css"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import BankIcon from "../../svg/new/bank"
import parse from "html-react-parser"

const Benefits = ({ benefitsShowSection, benefitsTitle, benefitsSubTitle, benefitsContent, benefitList }) => {
  return (
    <>
      {benefitsShowSection === "yes" && (
        <section>
          <div className="container">
            <div className={style.benefitsWapper}>
              <SectionsTitle
                title={replaceUnderscoresWithSpaces(benefitsTitle)}
                SubTitle={benefitsSubTitle}
                styleCss={{ display: "none" }}
                Content={benefitsContent}
                classnames={`${style.benefits_main_title} bgBlackHeading`}
              />
              <div className={style.cardWapper}>
                <ul className={style.cardList}>
                  {benefitList?.length && benefitList?.map((item) => {
                    return (
                      <li>
                        <div className={style.cardTitle}>
                          <i>{item.benefitsListIcon ? parse(`${item.benefitsListIcon}`) : <BankIcon />}</i>
                          <h3>{item?.benefitsListTitle}</h3>
                        </div>
                        <p>{parse(`${item.benefitsListContent}`)}</p>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default Benefits
